import { Component, OnInit, Injectable, Inject } from '@angular/core';
import {MatSnackBar, MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  activeStyle: string = "INFO";
  showSnackBar: boolean = true;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBar:
  MatSnackBar) { }

}